import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto p-5">
      <div className="flex items-center gap-5 mb-2.5">
        <img src="/Maestro Basic Logo.png" alt="Maestro Logo" className="h-12 max-w-[200px] object-contain" />
        <h1 className="text-3xl font-bold text-gray-800">Urban Tech Initiative</h1>
      </div>

      <div className="mt-7">
        <section className="text-center py-10 px-5 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg mb-10">
          <p className="text-2xl text-white font-medium m-0">
            This is the home of the Urban Tech initiative.
          </p>
        </section>

        <section className="mb-10">
          <h2 className="text-blue-600 mb-5 text-3xl">Våra Projekt</h2>

          <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-blue-600 mb-5">
            <h3 className="text-gray-800 mt-0 mb-4 text-2xl">
              Projekt 1: Playbook för ny hälsa och nya stadsmönster
            </h3>
            <p className="text-gray-600 leading-relaxed mb-5">
              En omfattande guide för att skapa hälsosamma och hållbara stadsmiljöer
              som främjar välbefinnande och social sammanhållning.
            </p>
            <div>
              <h4 className="text-blue-600 mb-2.5 text-lg">Verktyg:</h4>
              <Link
                to="/walking-distance"
                className="inline-block py-3 px-5 bg-blue-600 text-white no-underline rounded transition-colors hover:bg-blue-700 font-medium"
              >
                Promenadavstånd Kalkylator - Hitta service och platser inom 10 minuters promenad
              </Link>
            </div>
          </div>
        </section>

        <section className="bg-gray-100 p-6 rounded-lg">
          <h2 className="text-blue-600 mt-0 mb-4 text-2xl">Om Urban Tech</h2>
          <p className="text-gray-600 leading-relaxed">
            Urban Tech-initiativet arbetar med att utveckla verktyg och metoder
            för att skapa bättre, mer hållbara och hälsosamma städer.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Home;
